import { useQuery } from '@tanstack/react-query';
import apiClient from '../services/apiService';

export const useCustomers = (page = 1, filters = {}) => {
  return useQuery({
    queryKey: ['customers', page, filters],
    queryFn: async () => {
      const response = await apiClient.get('/api/customers', {
        params: { page, ...filters },
      });
      
      return {
        customers: response.data || [],
        pagination: {
          currentPage: response.current_page || 1,
          firstPageUrl: response.first_page_url,
          from: response.from,
          lastPage: response.last_page || 1,
          lastPageUrl: response.last_page_url,
          links: response.links || [],
          nextPageUrl: response.next_page_url,
          path: response.path,
          perPage: response.per_page,
          prevPageUrl: response.prev_page_url,
          to: response.to,
          total: response.total || 0,
        },
      };
    },
    staleTime: 5 * 60 * 1000,
  });
};
